const defaultAccess: string[] = [
  'Chief',
  'Admin',
  'Viewer',
  'CncAdmin',
  'CncChief',
  'CncViewer',
  'CncSupervisor',
];
const qcAccess = ['CncQC', 'QualityControl', 'QualityControlInspector'];
const cleaningAccess = ['CncCleaning', 'CncLeader', 'CncSupervisor'];
const schedulingAccess = [
  ...defaultAccess,
  'CncProgrammer',
  'CncOperator',
  'CncLeader',
];
const allAccess = [
  ...schedulingAccess,
  ...qcAccess,
  ...cleaningAccess,
  'CncDeveloper',
  'Programmer',
];

export const cncAccionesRoles = {
  sharedActions: {
    scheduler: [...schedulingAccess],
    cleaning: [...defaultAccess, ...cleaningAccess],
    qualityControl: [
      'Chief',
      'Admin',
      'Viewer',
      'CncAdmin',
      'CncChief',
      ...qcAccess,
    ],
    qcData: [
      'Chief',
      'Admin',
      'Viewer',
      'CncAdmin',
      'CncChief',
      'QualityControl',
      'CncEngineer',
    ],
    cncProjects: [...defaultAccess, 'CncLeader', 'CncProgrammer'],
    cncValidation: [...defaultAccess, 'CncLeader', 'CncCleaning'],
    bolbar: [...defaultAccess],
    usersList: [...defaultAccess, 'CncEngineer'],
    efficiency: [
      'Chief',
      'Admin',
      'CncAdmin',
      'CncChief',
      'CncSupervisor',
      'StandardsAdmin',
      'CncStandardsAdmin',
      'CncEngineer',
    ],
    packingBox: [
      'Chief',
      'Admin',
      'LabelOperator',
      'CncSupervisor',
      'CncLabelOperator',
    ],
    users: [
      'Admin',
      'Chief',
      'CncAdmin',
      'CncChief',
      'CncSupervisor',
      'CncEngineer',
    ],
  },

  routerActions: {
    schedulingRoot: [...schedulingAccess],
    schedulingCleaning: [...defaultAccess, ...cleaningAccess],
  },

  sideNavActions: {
    main: [...allAccess, 'CncStandardsAdmin', 'CncEngineer'],
    reportsPbiCnc: [...defaultAccess],
  },
};
